import React, { useEffect, useState } from 'react';
import { Button, Input } from 'antd';

const NameFilter = ({
  filters,
  placeholder,
  confirm,
  onSubmit,
  onReset,
  status,
}) => {
  const [value, setValue] = useState(filters.name);

  useEffect(() => {
    setValue(filters.name);
  }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleReset = () => {
    confirm();
    onReset();
    setValue(null);
  };

  const handleSubmit = () => {
    confirm();
    onSubmit(value);
  };

  return (
    <div style={{ padding: 8, minHeight: '80px' }}>
      <Input
        style={{ marginBottom: 8 }}
        value={value}
        onChange={handleChange}
        onPressEnter={handleSubmit}
        placeholder={placeholder}
      />
      <div>
        <Button
          type="primary"
          role="search"
          onClick={handleSubmit}
          style={{ float: 'right' }}
          //icon={<SearchOutlined />}
          size="small"
        >
          Search
        </Button>
        <Button
          role="reset"
          style={{
            border: 'none',
            marginRight: '8px',
            color: '#3C9AE8',
            float: 'right',
          }}
          onClick={handleReset}
          size="small"
        >
          Clear
        </Button>
      </div>
    </div>
  );
};

export default NameFilter;
